/* eslint-disable indent */
import { Vue, Component, Ref } from 'vue-property-decorator'
import ScientificAnalysisSaveModal from '@/modules/scientific-analysis-module/components/scientific-analysis-save-modal/scientific-analysis-save-modal.vue'
import ScientificAnalysisSaveModalComp from '@/modules/scientific-analysis-module/components/scientific-analysis-save-modal/scientific-analysis-save-modal'
import ScientificAnalysisRenameModal from '@/modules/scientific-analysis-module/components/scientific-analysis-rename-modal/scientific-analysis-rename-modal.vue'
import ScientificAnalysisRenameModalComp from '@/modules/scientific-analysis-module/components/scientific-analysis-rename-modal/scientific-analysis-rename-modal'
import ScientificAnalysisImportModal from '@/modules/scientific-analysis-module/components/scientific-analysis-import-modal/scientific-analysis-import-modal.vue'
import ScientificAnalysisImportModalComp from '@/modules/scientific-analysis-module/components/scientific-analysis-import-modal/scientific-analysis-import-modal'
import ScientificAnalysisDetailModal from '@/modules/scientific-analysis-module/components/scientific-analysis-detail-modal/scientific-analysis-detail-modal.vue'
import ScientificAnalysisDetailModalComp from '@/modules/scientific-analysis-module/components/scientific-analysis-detail-modal/scientific-analysis-detail-modal'
import { initialScientificAnalysisSearchTabTemplatesState, ScientificAnalysisSearchTabTemplatesState, ScientificAnalysisTemplateHeaderVO } from '@/modules/scientific-analysis-module/components/scientific-analysis-search-tab-templates/scientific-analysis-search-tab-templates.models'
import { scientificAnalysisService, ScientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import i18n from '@/lang/i18n'

@Component({
    components: {
        ScientificAnalysisSaveModal,
        ScientificAnalysisRenameModal,
        ScientificAnalysisDetailModal,
        ScientificAnalysisImportModal
    }
})
export default class ScientificAnalysisSearchTabTemplates extends Vue {
    public static EVENT_DELETED_TEMPLATE = 'deleted-template'
    public static EVENT_LOADED_TEMPLATE = 'template-load'

    state: ScientificAnalysisSearchTabTemplatesState
    service:ScientificAnalysisService=scientificAnalysisService
    @Ref('scientificAnalysisSaveModal') readonly scientificAnalysisSaveModal!: ScientificAnalysisSaveModalComp
    @Ref('scientificAnalysisRenameModal') readonly scientificAnalysisRenameModal!: ScientificAnalysisRenameModalComp
    @Ref('scientificAnalysisDetailModal') readonly scientificAnalysisDetailModal!: ScientificAnalysisDetailModalComp
    @Ref('scientificAnalysisImportModal') readonly scientificAnalysisImportModal!: ScientificAnalysisImportModalComp

    constructor() {
        super()
        this.state = initialScientificAnalysisSearchTabTemplatesState()
    }

    get _savedSearchesCount(): number {
        return this.state.savedSearches.length
    }

    get _showSelection(): boolean {
        return this.state.selectSavedSearchesEnabled
    }

    get _disableExportButton(): boolean {
        return !this.isThereAnyTemplateSelected()
    }

    get _disableDeleteButton(): boolean {
        return !this.isThereAnyTemplateSelected()
    }

    private isThereAnyTemplateSelected(): boolean {
        if (this._showSelection) {
            if (this.state.savedSearches.some(savedSearch => savedSearch.selected)) {
                return true
            }
        }
        return false
    }

    _onToogleSavedSearchSelection(): void {
        this.state.selectSavedSearchesEnabled = !this.state.selectSavedSearchesEnabled
    }

    private async loadSavedTemplates(): Promise<void> {
        const savedTemplates = await this.$_toCallSecureLoading(this.service.getAllTemplates())
        if (savedTemplates) {
            this.state.savedSearches = savedTemplates.map(template => {
                return {
                    selected: false,
                    dto: template
                } as ScientificAnalysisTemplateHeaderVO
            })
        }
    }

    _onImportSearchClick(): void {
        this.scientificAnalysisImportModal.show()
    }

    _onShowDetailsClick(template: ScientificAnalysisTemplateHeaderVO): void {
        this.scientificAnalysisDetailModal.show(template.dto)
    }

    _onRenameClick(template: ScientificAnalysisTemplateHeaderVO): void {
        this.scientificAnalysisRenameModal.show(template.dto.id, template.dto.name)
    }

    _onTemplateRenamed(): void {
        this.loadSavedTemplates()
    }

    _onSelectAllToogle(checked:boolean): void {
        this.state.savedSearches.forEach(vo => { vo.selected = checked })
    }

    async update(): Promise<void> {
        await this.loadSavedTemplates()
    }

    async _onTemplateLoadClick(templatevo: ScientificAnalysisTemplateHeaderVO): Promise<void> {
        if (!this._showSelection) {
            const template = await this.$_toCallSecureLoading(this.service.getTemplate(templatevo.dto.id))
            if (template) { this.$emit(ScientificAnalysisSearchTabTemplates.EVENT_LOADED_TEMPLATE, template) }
        }
    }

    _onImport(): void {
        this.loadSavedTemplates()
    }

    async _onExportClick(template: ScientificAnalysisTemplateHeaderVO): Promise<void> {
        if (this._showSelection) {
            const ids = this.state.savedSearches.filter(template => template.selected).map(template => template.dto.id)
            this.$_updateLoading(true)
            const exported = await this.$_toCallSecureLoading(this.service.exportTemplates(ids))
            if (exported) {
                this.state.selectSavedSearchesEnabled = false
                this.$_updateLoading(false)
            }
        } else {
            this.$_updateLoading(true)
            const exported = await this.$_toCallSecureLoading(this.service.exportTemplates([template.dto.id]))
            if (exported) { this.$_updateLoading(false) }
        }
        this.$_showToastSuccess(i18n.tc('scientificAnalysis.sidebar.exportsuccess'))
    }

    async _onRemoveClick(template?: ScientificAnalysisTemplateHeaderVO): Promise<void> {
        if (this._showSelection) {
            if (!this.state.savedSearches.some(savedSearch => savedSearch.selected)) {
                return
            }
        }

        const confirmation = await this.$_showConfirmationModal(i18n.tc('scientificAnalysis.sidebar.deleteQuestion'))
        if (confirmation) {
            this.$_updateLoading(true)
            if (this._showSelection) {
                for (const savedSearch of this.state.savedSearches) {
                    if (savedSearch.selected) {
                        if (await this.$_toCallSecureLoading(this.service.removeTemplate(savedSearch.dto.id))) {
                            this.$emit(ScientificAnalysisSearchTabTemplates.EVENT_DELETED_TEMPLATE, savedSearch.dto.id)
                        }
                    }
                }
                this.state.selectSavedSearchesEnabled = false
            } else if (template) {
                if (await this.$_toCallSecureLoading(this.service.removeTemplate(template.dto.id))) {
                    this.$emit(ScientificAnalysisSearchTabTemplates.EVENT_DELETED_TEMPLATE, template.dto.id)
                }
            }

            this.$_showToastSuccess(i18n.tc('scientificAnalysis.sidebar.deleteSuccess'))
            this.loadSavedTemplates()
            this.$_updateLoading(false)
        }
    }

    _onPopupClick(event:Event): void {
        event.stopPropagation()
    }
}
